import { render, staticRenderFns } from "./null.vue?vue&type=template&id=4a8a0767&scoped=true&"
import script from "./null.vue?vue&type=script&lang=js&"
export * from "./null.vue?vue&type=script&lang=js&"
import style0 from "./null.vue?vue&type=style&index=0&id=4a8a0767&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a8a0767",
  null
  
)

export default component.exports